import React from 'react';
import {Card, CardHeader, CardText} from 'material-ui/Card';
import {List, ListItem} from 'material-ui/List';
import { Link } from 'react-router';
import {Toolbar, ToolbarGroup} from 'material-ui/Toolbar';
import IconMenu from 'material-ui/IconMenu';
import IconButton from 'material-ui/IconButton/IconButton';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import EditIcon from 'material-ui/svg-icons/editor/mode-edit';
import DeleteIcon from 'material-ui/svg-icons/action/delete';
import DeleteCategoryModal from '../components/DeleteCategoryModal';
import PropTypes from 'prop-types';
import {adminCardStyle} from '../containers/AdminHomepage';

class CategoryItem extends React.Component {

  constructor(props) {
    super(props);
    this.onDeleteTapped = props.onDeleteTapped.bind(null, props, props.items.length);
  }

  render() {
    let props = this.props;
    let catTr = props.translation ? props.translation.categories.find(c => c.engID === props.id) : null
    let catTitle = catTr ? props.title + " - " + catTr.title : props.title;

    return (
      <Card style={adminCardStyle}>
        <Toolbar>
          <ToolbarGroup firstChild={true}>
          <CardHeader title={catTitle} subtitle={props.showCategoryDescription ? props.description : ""} />
          </ToolbarGroup>
          {
            props.editable && <ToolbarGroup>
              <IconButton tooltip="Edit Category" containerElement={<Link to={"/admin/categories/" + props.id} />}>
                <EditIcon color="grey" />
              </IconButton>
              <IconButton tooltip="Delete Category" onClick={this.onDeleteTapped}>
                <DeleteIcon color="grey" />
              </IconButton>
            </ToolbarGroup>
          }
        </Toolbar>
        <CardText>
          <List>
          {
            //bjs 10/13/21 is right icon ever "more than one"?
            props.items.map((item) => {
              var rightIcon = null;
              let numSections = ['monitoring', 'assessment', 'controlRules'].reduce((num, section) => {
                if (item.domainLogic && item.domainLogic[section] && item.domainLogic[section].type !== 'none') {
                  num++;
                  return num;
                } else {
                  return num;
                }
              }, 0);
              if (numSections > 1) {
                rightIcon = <span>More than one</span>
              }

              let text = item.id + ": " + item.title.replace(/<.*?>/gm, '')
              let hasTranslation = props.translation && props.translation.questions.find(trQ => trQ.engID === item.id)
              return <ListItem key={item.id} onClick={props.onItemClick.bind(null, item)} primaryText={text} secondaryText={hasTranslation ? props.translation.questions.find(trQ => trQ.engID === item.id).title.replace(/<.*?>/gm, '') : ""} rightIcon={rightIcon}><span id={"item-" + item.id} style={{position:"absolute", top: -70}}></span></ListItem>
            })
          }
          </List>
        </CardText>
      </Card>
    )
  }
}

class EditableCategorizedItemList extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      hideFAB: false
    }
    this.onClick = this.onClick.bind(this);
    this.handleCategoryDelete = this.handleCategoryDelete.bind(this);
    this.handleCategoryDeleteDismiss = this.handleCategoryDeleteDismiss.bind(this);
  }

  render() {
    var catType = this.props.categoryType ? this.props.categoryType : "category"; //determine if showing input categories or not
    return  (
      <div>
        {this.props.categories.map((category) => {
          let items = this.props.items.filter((i) => i[catType] === category.id);
          var filteredItems = items;
          if (this.props.itemFilter) {
            filteredItems = items.filter(this.props.itemFilter);
          }
          if (filteredItems.length || items.length === 0) { // length of 0 evals as false, items length = 0 catches categories that exist but dont have any options in any sections
            return <CategoryItem
                    key={category.id + category.title}
                    items={filteredItems}
                    onDeleteTapped={this.handleCategoryDelete}
                    onItemClick={this.onClick}
                    showCategoryDescription={this.props.showCategoryDescription}
                    editable={this.props.editable}
                    translation={this.props.translation}
                    {...category} />
          }
          //else return null? to test
        })}
        {
          this.props.editable && <IconMenu
            iconButtonElement={<FloatingActionButton secondary={true} style={{position: "fixed", right: "24px", bottom: 24}}>
              <ContentAdd />
            </FloatingActionButton>}
            anchorOrigin={{horizontal: 'middle', vertical: 'center'}}
            optionOrigin={{horizontal: 'right', vertical: 'bottom'}}
          >
            {this.props.fabItems}
          </IconMenu>
        }
        {
          this.state.categoryForDeletion ? <DeleteCategoryModal onDelete={this.props.deleteCategoryAction} numRelatedItems={this.state.numRelatedItems} onDismiss={this.handleCategoryDeleteDismiss} category={this.state.categoryForDeletion} otherCategories={this.props.categories.filter((c) => c.id !== this.state.categoryForDeletion.id)} /> : ""
        }
      </div>
    );
  }

  onClick(item) {
    this.props.onItemClick(item.id)
  }

  handleFAB() {
    this.setState({hideFAB: true})
  }

  handleCategoryDelete(category, numRelatedItems) {
    if (global.confirm("Are you sure? This action cannot be undone.")) {
      this.setState({
        categoryForDeletion: category,
        numRelatedItems
      });
    }
  }

  handleCategoryDeleteDismiss() {
    this.setState({categoryForDeletion: null});
  }
}


EditableCategorizedItemList.propTypes = {
  categories: PropTypes.array.isRequired,
  items: PropTypes.array.isRequired,
  deleteCategoryAction: PropTypes.func.isRequired,
  fabItems: PropTypes.array.isRequired,
  itemFilter: PropTypes.func,
  showCategoryDescription: PropTypes.bool
}

EditableCategorizedItemList.defaultProps = {
  showCategoryDescription: true,
  editable: true
}

export default EditableCategorizedItemList;
